export function createCodeSource(codeSource : string) : Array<string> {
  let splitCode = codeSource.split('\n')
  return splitCode;
}